export function postMessage(type: string, params: {} = {}, callbackId: string = '') {
  if ((window as any)._idvu && (window as any)._idvu.postMessage) {
    console.warn(`IDVU::${type}`, JSON.stringify(params))
    ;(window as any)._idvu.postMessage(type, callbackId, JSON.stringify(params))
  }
}
